import React from 'react'
import SiteGrid from "app/components/ui/SiteGrid"
import HelmetTitle from "app/meta/HelmetTitle"
import './styles/ArticlePage.css'
import { useArticle } from "app/hooks/blogHooks"
import { useNavigate, useParams } from "react-router-dom"
import { detectArticleReadingTime } from "app/utils/generalUtils"
import AppButton from "app/components/ui/AppButton"
import { blogsArray } from "app/data/blogData"
import { useTeamMember } from "app/hooks/teamHooks"
import Avatar from "app/components/ui/Avatar"
import { convertClassicDate } from "app/utils/dateUtils"

export default function ArticlePage() {

  const articleID = useParams().articleID
  const article = useArticle(articleID)
  const author = useTeamMember(article?.authorID)
  const navigate = useNavigate()

  const handleNextArticle = () => {
    const nextArticle = (+articleID + 1) % blogsArray.length
    navigate(`/blog/${nextArticle}`)
  }

  const handlePrevArticle = () => {
    const prevArticle = (+articleID - 1 + blogsArray.length) % blogsArray.length
    navigate(`/blog/${prevArticle}`)
  }

  return article && author ? (
    <div
      className="article-page"
      key={articleID}
    >
      <HelmetTitle title={article.title} />
      <SiteGrid>
        <div className="header">
          <div className="img-container">
            <img src={article.img} alt="" />
          </div>
          <div className="titles">
            <h1>{article.title}</h1>
            <div className="meta-info">
              <h6>
                <Avatar
                  src={author.img}
                  dimensions={35}
                  alt={author.name}
                />
                {author.name}
              </h6>
              <h6>&bull;</h6>
              <h6>{convertClassicDate(article.date)}</h6>
              <h6>&bull;</h6>
              <h6>{detectArticleReadingTime(article.content)} min. read</h6>
            </div>
          </div>
        </div>
        <div className="article-content">
          <div dangerouslySetInnerHTML={{ __html: article.content.replaceAll(/\n/g, "<br>") }} />
        </div>
        <div className="article-footer">
          <div className="social-media">
            <h5>Share on:</h5>
            <div className="social-media-icons">
              <i className="fab fa-facebook-f" />
              <i className="fab fa-twitter" />
              <i className="fab fa-linkedin-in" />
              <i className="fab fa-pinterest-p" />
            </div>
          </div>
          <div className="nav-container">
            <AppButton
              label="Previous Article"
              leftIcon="fal fa-arrow-left"
              buttonType="invertedBtn"
              onClick={handlePrevArticle}
            />
            <AppButton
              label="Next Article"
              rightIcon="fal fa-arrow-right"
              buttonType="invertedBtn"
              onClick={handleNextArticle}
            />
          </div>
        </div>
      </SiteGrid>
    </div>
  ) :
    null
}
